module.exports = __webpack_public_path__ + "img/legacy_2.886a06f3.jpg";